import {Fragment, useEffect, useId, useState} from 'react';

interface Props {
  items: any;
}

export function DetailInfoSuggested({items}: Props) {

  const [keys, setKeys] = useState<any>([]);
  useEffect(() => {
    if (items) {
      setKeys(items && items[0] ? Object.keys(items[0]) : Object.keys(items));
    }
  }, [items]);

  if (items) {
    return (
      <Fragment>

        <div className="flex flex-wrap">
          <div className='w-full'>
          {keys.length> 1 ? (<>
            <table className="w-full file">
              <thead className="bg-white border-b sticky top-0 bg-slate-300">
                <tr className='bg-gray-300'>
                  {keys.map((header: string, index: number) => (
                  <th scope="col" className={index == 0 ? "bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 pl-20 text-left": "bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left"}>
                    {capitalizeFirstLetter(header.toString())}
                  </th>
                  ))}
                </tr>
              </thead>

              <tbody className="overflow-y-auto">
                <tr className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100">
                  {keys.map((header: string, index: number) => {
                    const val = items[0] ? items[0][header] : items[header];
                    if (val != null) {
                      if (typeof val === 'string' || val instanceof String || typeof val === 'number') {
                        return (
                          <td className={index==0? "text-sm font-extrabold text-gray-900 font-light px-6 py-4 pl-20 whitespace-nowrap":"text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap"}>
                            {val}
                          </td>
                        );
                      }
                    }
                  })}
                </tr>
              </tbody>
            </table>
          </>):(<></>)}
          </div>
        </div>
      </Fragment>
    );
  }
}

function capitalizeFirstLetter(s: string) {
  return s.replaceAll("_", " ").toUpperCase();
}
